import { observer } from "mobx-react";
import Layout from "../../../utils/layout";
import useStore from "../../../hooks/useStore";
import React, { useState } from "react";
import SetKpiFilter from "./setKpiFilter";
import SetKpiTargetTableBody from "./SetKpiTargetTableBody";
import { useAuth } from "../../../context/authProvider";

const SetKpiTarget = () => {
  const [filters, setFilters] = useState({
    year: null,
    category: null,
    subCategory: null,
    kpi: null,
  });

  const [updatedTargetData, setUpdatedTargetData] = useState([]);
  const { showAlert } = useAuth();
const [isSaving, setIsSaving] = useState(false);

  const {
    companyStore: {
      fetchSetKpiTargetListRaw,
      setKpiTargetList,
      saveSetKpiTarget,
    },
  } = useStore();

  const tablehead = [
    "Sr.No",
    "Category",
    "Sub Category",
    "KPI Name",
    "Field Name",
    "Target",
  ];

  const handleSave = () => {
  console.log("updatedTargetData", updatedTargetData); // debug log

  if (!Array.isArray(updatedTargetData) || updatedTargetData.length === 0) {
    alert("No target values to save.");
    return;
  }
  setIsSaving(true); // Start text loader

  const finalPayload = updatedTargetData.map((item) => ({
   
  ...item,
  year: filters.year,
  fieldId: Number(item.fieldId),
  catId: Number(item.catId),
  subCatId: Number(item.subCatId),
  kpiId: Number(item.kpiId),
  target: item.target === "" ? 0 : Number(item.target),
}));


  saveSetKpiTarget({
    updatedList: finalPayload,
    onSuccess: () => {
      fetchSetKpiTargetListRaw({
        filter: {
          year: filters.year,
          category: filters.category?.value,
          subCategory: filters.subCategory?.value,
          kpi: filters.kpi?.value,
        },
      });
      showAlert("Target values saved successfully.", true);
       setIsSaving(false);
    },
    onError: () => {
      showAlert("Failed to save target values.");
       setIsSaving(false);
    },
  });
};


  return (
    <Layout>
      <div className="categories">
        <div className="container-fluid">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 font-size-18">Set KPI Target</h4>
            </div>

            <SetKpiFilter filters={filters} setFilters={setFilters} />

            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table align-middle table-bordered table-nowrap mb-0">
                    <thead>
                      <tr>
                        {tablehead.map((item, index) => (
                          <th key={index}>{item}</th>
                        ))}
                      </tr>
                    </thead>
                    <SetKpiTargetTableBody
                      listData={setKpiTargetList || []}
                      onDataChange={setUpdatedTargetData}
                    />
                  </table>
                </div>
                <div className="mt-3 text-end">
                <button className="btn btn-primary" onClick={handleSave} disabled={isSaving}>
                  {isSaving ? "Saving..." : "Save Target"}
                </button>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default observer(SetKpiTarget);
